import React from 'react';

/**
 * Trailing actions cell.
 * Renders a "+" button on the last data row (when onAddRow is supplied and
 * canAdd !== false) and a trash icon on every row (when onDeleteRow is
 * supplied and canDelete !== false). Hidden on pinned footer rows. An in-grid
 * total row flagged with __cagTotal is treated as a terminator (like the pinned
 * footer) so the "+" still lands on the last data row above it.
 *
 * cellRendererParams:
 *   onAddRow()
 *   onDeleteRow(rowId)
 *   getRowId(row) -> string
 *   canAdd         boolean (default true)
 *   canDelete      boolean (default true)
 */
function RowActionsCell(params) {
  const { data, node, api, onAddRow, onDeleteRow, getRowId, canAdd = true, canDelete = true, extras = null } = params;

  if (node?.rowPinned) return null;

  const rowId = getRowId ? getRowId(data) : data?.id;

  /* "Last data row" means there is no next row, or the next row is pinned (footer). */
  const isLastRow = (() => {
    if (!api || node?.rowIndex == null) return false;
    const next = api.getDisplayedRowAtIndex(node.rowIndex + 1);
    return !next || Boolean(next.rowPinned) || Boolean(next.data?.__cagTotal);
  })();

  return (
    <div className="cag-row-actions">
      {extras ? <span className="cag-row-actions__extras">{extras}</span> : null}
      {onAddRow && isLastRow && canAdd ? (
        <button type="button" className="bombiix-icon-container bombiix-icon-container--blue" title="Add row" aria-label="Add row" onClick={() => onAddRow()}>
          <i className="bombiix-icon-add" />
        </button>
      ) : null}
      {onDeleteRow && canDelete ? (
        <button
          type="button"
          className="bombiix-icon-container bombiix-icon-container--red"
          title="Delete row"
          aria-label="Delete row"
          onClick={() => onDeleteRow(rowId)}
        >
          <i className="bombiix-icon-delete" />
        </button>
      ) : null}
    </div>
  );
}

export default RowActionsCell;
